/**
 * Organizations event types for durable event recording (org.* + user-group.*).
 */
export enum OrganizationsEventType {
  ORG_CREATED = 'organizations:org.created',
  ORG_UPDATED = 'organizations:org.updated',
  ORG_DELETED = 'organizations:org.deleted',
  ORG_MEMBER_ADDED = 'organizations:org.member.added',
  ORG_MEMBER_REMOVED = 'organizations:org.member.removed',
  USER_GROUP_CREATED = 'organizations:user-group.created',
  USER_GROUP_UPDATED = 'organizations:user-group.updated',
  USER_GROUP_DELETED = 'organizations:user-group.deleted',
  USER_GROUP_MEMBER_ADDED = 'organizations:user-group.member.added',
  USER_GROUP_MEMBER_REMOVED = 'organizations:user-group.member.removed',
}

/**
 * Pub/sub channel for organizations events.
 */
export const ORGANIZATIONS_EVENTS_CHANNEL = 'organizations:events';